import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";
import { useEffect } from "react";
import {DiscoverBreadcrumbs} from "features/discover/DiscoverBreadcrumbs";
import {DiscoverGamesTable} from "features/discover/DiscoverGamesTable";

export function DiscoverGamesPage() {
    useEffect(() => { setScrollBehavior() }, []);

	return (
		<div className="discover-container discover-container--wide">
			<div className="pageHeading">
				<DiscoverBreadcrumbs items={[
					{
						label: 'Games',
					},
				]}/>
			</div>
			<div className="discover-card discover-card--for-table">
				<DiscoverGamesTable />
			</div>
		</div>
	)
}
